import React, {ReactElement} from 'react';
import useContentfulHeaderLinks from '../../../../useContentfulHeaderLinks';
import HeaderContainer from './HeaderContainer';

type Props = {
  showLinks?: boolean;
  focusMode?: boolean;
};

function Header({showLinks, focusMode}: Props): ReactElement {
  const data = useContentfulHeaderLinks();
  return <HeaderContainer data={data} showLinks={showLinks} focusMode={focusMode} />;
}

export default Header;
